import { render } from "./textMore.vue?vue&type=template&id=f08171cc"
import script from "./textMore.vue?vue&type=script&lang=js"
export * from "./textMore.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__